import $ from "jquery";

export const ProfileCreated = function () {
	if (!($(".profile-created").length > 0)) return false;

	// Override browser back button behavior
	const overrideBackButton = () => {
		// Get user_id from the current URL or page data
		const user_id =
			window.location.pathname.split("/").pop() ||
			$("[data-user-id]").data("user-id") ||
			$(".setup__form-button")
				.attr("onclick")
				?.match(/\/edit-profile\/(\d+)/)?.[1];

		if (user_id) {
			// Push current state to history
			window.history.pushState(
				{ page: "profile-created", user_id: user_id },
				"",
				window.location.href,
			);

			// Listen for popstate (back button)
			window.addEventListener("popstate", function () {
				// Prevent default back behavior and redirect to edit-profile
				window.location.href = `${window.location.origin}/edit-profile/${user_id}`;
			});

			// Also handle beforeunload to ensure proper state management
			window.addEventListener("beforeunload", function () {
				// Clean up if needed
			});
		}
	};

	// Initialize back button override
	overrideBackButton();
};
